import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatToolbarModule } from '@angular/material/toolbar';
import { IntakeEvictionService } from './services/intake-eviction.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EvictionIntakeModule } from '@ee/common/eviction-intake';
import { MatIconModule } from '@angular/material/icon';
import {MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { WafTokenInterceptor } from '@ee/common/services';
import { LoadingModule } from '@ee/common/loading';
import { LayoutModule } from '@angular/cdk/layout';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { popperVariation, provideTippyConfig, provideTippyLoader } from '@ngneat/helipopper/config';

@NgModule({ declarations: [AppComponent],
  bootstrap: [AppComponent], imports: [BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    MatToolbarModule,
    RouterModule.forChild([]),
    EvictionIntakeModule.forRoot(environment),
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    MatLuxonDateModule,
    MatListModule,
    LoadingModule,
    LayoutModule
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    IntakeEvictionService,
    provideTippyLoader(() => import('tippy.js')),
    provideTippyConfig({
      defaultVariation: 'tooltip',
      variations: {
        tooltip: {
          theme: null,
          arrow: true,
          animation: 'scale',
          trigger: 'mouseenter',
          offset: [0, 5]
        },
        popper: popperVariation
      }
    }),
    { provide: 'environment', useValue: environment }, provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: WafTokenInterceptor, multi: true },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline', subscriptSizing: 'dynamic' } },
  ]
})
export class AppModule {
  constructor() {}
}
